import HomeView from '@/home/presentation/HomeView.vue';
import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import routes from './routes'

const routesConfig: Array<RouteRecordRaw> = [
    {
        path: routes.home.path,
        name: routes.home.name,
        component: HomeView
    },
    {
        path: routes.survey.path,
        name: routes.survey.name,
        component: () => import(/* webpackChunkName: "survey" */ '../../survey/presentation/view/SurveyView.vue')
    },
    {
        path: routes.thankYouPage.path,
        name: routes.thankYouPage.name,
        component: () => import(/* webpackChunkName: "thank-you-page" */ '../../thank_you_page/presentation/view/ThankYouPageView.vue')
    },
    {
        path: routes.send.path,
        name: routes.send.name,
        component: () => import(/* webpackChunkName: "thank-you-page" */ '../../send/presentation/view/SendView.vue'),
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: () => import(/* webpackChunkName: "not-found" */ '../../not_found/presentation/view/NotFoundView.vue')
    }

]

const router = createRouter({
    history: createWebHistory(),
    routes: routesConfig
})

export default router;
